// Supermove
import {AccountGrantModel} from '@supermove/models';

export const sortAccountGrants = (a: AccountGrantModel, b: AccountGrantModel) => {
  if (a.isPrimary && !b.isPrimary) {
    return -1;
  }
  if (!a.isPrimary && b.isPrimary) {
    return 1;
  }
  if (a.status === 'ACTIVE' && b.status === 'INACTIVE') {
    return -1;
  }
  if (a.status === 'INACTIVE' && b.status === 'ACTIVE') {
    return 1;
  }
  return a.identifier.localeCompare(b.identifier);
};
